export const publications = {
  2026: [
    {
      authors: "D'Amato, Q., Mannucci, F., De Rubeis, E. et al., including Janiuk, A.",
      title: 'LoTSS of dual AGN: enhanced detectability and prospects for a systematic search',
      journal: 'arXiv preprint, 2026',
      links: [{ label: 'arXiv:2609.22449', url: 'https://doi.org/10.48550/arXiv.2609.22449' }]
    },
    {
      authors: 'Urrutia, G., De Colle, F., Janiuk, A., Moreno, C., Ramirez-Ruiz, E.',
      title: 'The Hidden Evolution of Gamma-Ray Burst Jets Revealed by Gravitational Waves',
      journal: 'arXiv preprint (submitted to ApJ), 2026',
      links: [{ label: 'arXiv:2609.17776', url: 'https://doi.org/10.48550/arXiv.2609.17776' }]
    },
    {
      authors: 'Urrutia, G., Janiuk, A., Olivares, H.',
      title: 'Numerical simulations of jet launching and breakout from collapsars',
      journal: 'Journal of High Energy Astrophysics, Volume 53, 100602, 2026',
      links: [
        { label: 'DOI', url: 'https://doi.org/10.1016/j.jheap.2026.100602' },
        { label: 'ScienceDirect', url: 'https://www.sciencedirect.com/science/article/pii/S2214404826000546' }
      ]
    },
    {
      authors: 'Płonka, P., Janiuk, A.',
      title: 'Three-dimensional general relativistic MHD simulations of jet formation and propagation in self-gravitating collapsing stars',
      journal: 'Astronomy & Astrophysics, Volume 709, A80, 2026',
      links: [{ label: 'DOI', url: 'https://doi.org/10.1051/0004-6361/202558355' }]
    },
    {
      authors: 'Janiuk, A., Saji, J., Urrutia, G.',
      title: 'Chemical evolution and kilonova implications of post-merger accretion disk winds',
      journal: 'Astronomy & Astrophysics, Volume 707, A307, 2026',
      links: [{ label: 'DOI', url: 'https://doi.org/10.1051/0004-6361/202557832' }]
    },
    {
      authors: 'Urrutia, G., Janiuk, A.',
      title: 'The propagation of long GRB jets through and beyond its progenitor star',
      journal: 'arXiv preprint (conference proceedings), 2026',
      links: [{ label: 'arXiv:2601.00079', url: 'https://doi.org/10.48550/arXiv.2601.00079' }]
    },
  ],
  2025: [
    {
      authors: 'Janiuk, A., Czerny, B., Ojha, P., Cavecchi, Y., Vincentelli, F.',
      title: 'Radiation pressure instability: from heart-beat states in black hole binary systems to Quasars and Changing-Look AGN',
      journal: 'Proceedings of Science (DIM50th2025, Tomakomai, Japan), 2025',
      links: [{ label: 'arXiv:2512.08502', url: 'https://arxiv.org/abs/2512.08502' }]
    },
    {
      authors: 'Janiuk, A., Urrutia, G., Saji, J., Płonka, P.',
      title: 'Relativistic MHD simulations of merging and collapsing stars and effects on GRB transient',
      journal: 'Proceedings of Science (HEPRO IX, Rio de Janeiro, Brazil), 2025',
      links: [{ label: 'arXiv:2512.08489', url: 'https://arxiv.org/abs/2512.08489' }]
    },
    {
      authors: 'Saji, J., Dainotti, M.G., Bhardwaj, S., Janiuk, A.',
      title: 'Exploring jet structure and dynamics in short gamma-ray bursts: A case study on GRB 090510',
      journal: 'Astronomy and Astrophysics, vol 702, A13, 2025',
      links: [{ label: 'DOI', url: 'https://doi.org/10.1051/0004-6361/202554147' }]
    },
    {
      authors: 'Urrutia, G., Janiuk, A., Nouri, F.H.',
      title: 'The impact of disc outflows on the structure of short GRB jets at large scales',
      journal: 'Monthly Notices of the Royal Astronomical Society, Volume 538, Issue 2, pp.1247-1263, 2025',
      links: [
        { label: 'DOI', url: 'https://doi.org/10.1093/mnras/staf377' },
        { label: 'arXiv', url: 'https://arxiv.org/abs/2401.10094' }
      ]
    },
    {
      authors: 'Janiuk, A., Janiuk, I., Król, D. Ł., Plonka, P., Urrutia, G., Saji, J.',
      title: 'Relativistic MHD simulations of merging and collapsing stars',
      journal: 'Procedia Computer Science, Volume 255, Pages 150-158, 2025',
      links: [{ label: 'DOI', url: 'https://doi.org/10.1016/j.procs.2025.02.270' }]
    },
  ],
  2024: [
    {
      authors: 'Nalewajko, K., Kapusta, M., Janiuk, A.',
      title: 'Chaotic magnetic disconnections trigger flux eruptions in accretion flows channeled onto magnetically saturated Kerr black holes',
      journal: 'Astronomy & Astrophysics, Volume 692, id.A37, 2024',
      links: [{ label: 'DOI', url: 'https://doi.org/10.1051/0004-6361/202450490' }]
    },
    {
      authors: 'Nicholl, M., Pasham, D. R., Mummery, A. et al., including Janiuk, A.',
      title: 'Quasi-periodic X-ray eruptions years after a nearby tidal disruption event',
      journal: 'Nature, Vol 634, 804, 2024',
      links: [{ label: 'DOI', url: 'https://doi.org/10.1038/s41586-024-08023-6' }]
    },
    {
      authors: 'James, B., Janiuk, A., Karas, V.',
      title: 'Black hole outflows initiated by a large-scale magnetic field; Effects of aligned and misaligned spin',
      journal: 'Astronomy and Astrophysics, vol 687, A185, 2024',
      links: [{ label: 'DOI', url: 'https://doi.org/10.1051/0004-6361/202349134' }]
    },
    {
      authors: 'Nouri, F.H., Janiuk, A.',
      title: 'Viscous torque in turbulent magnetized active galactic nucleus accretion disks and its effects on the gravitational waves of extreme mass ratio inspirals',
      journal: 'Astronomy and Astrophysics, vol 687, A184, 2024',
      links: [{ label: 'DOI', url: 'https://doi.org/10.1051/0004-6361/202348796' }]
    },
    {
      authors: 'Pasham, D. R., Zajaček, M., Nixon, C.J. et al., including Janiuk, A.',
      title: 'Lense–Thirring precession after a supermassive black hole disrupts a star',
      journal: 'Nature, Vol 630, 325, 2024',
      links: [{ label: 'DOI', url: 'https://doi.org/10.1038/s41586-024-07433-w' }]
    },
    {
      authors: 'Zdziarski, A. A., Chand, S., Banerjee, S., including Janiuk, A.',
      title: 'What Is the Black Hole Spin in Cyg X-1?',
      journal: 'The Astrophysical Journal Letters, vol 967, L9, 2024',
      links: [{ label: 'DOI', url: 'https://doi.org/10.3847/2041-8213/ad43ed' }]
    },
    {
      authors: 'Pasham, D. R., Coughlin, E. R., Zajaček, M., et al., including Janiuk, A.',
      title: 'Alive but Barely Kicking: News from 3+ yr of Swift and XMM-Newton X-Ray Monitoring of Quasiperiodic Eruptions from eRO-QPE1',
      journal: 'The Astrophysical Journal Letters, Vol. 963, No. 2, L47, 2024',
      links: [{ label: 'DOI', url: 'https://dx.doi.org/10.3847/2041-8213/ad2a5c' }]
    },
    {
      authors: 'Pasham, D. R., Tombesi, F., Sukova, P., Zajacek, M., including Janiuk, A.',
      title: 'Repeating Extragalactic Nuclear Transients as Extreme Mass Ratio Binaries',
      journal: 'Bulletin of the American Astronomical Society, Vol. 56, No. 2, 2024',
      links: [{ label: 'ADS', url: 'https://ui.adsabs.harvard.edu/abs/2024AAS...24342602P/abstract' }]
    },
  ],
  2023: [
    {
      authors: 'Janiuk, A., Shahamat Dehsorkh, N., Król, D.',
      title: 'Self-gravitating collapsing star and black hole spin-up in long gamma ray bursts',
      journal: 'Astronomy and Astrophysics, Vol. 677, A19, 2023',
      links: [{ label: 'DOI', url: 'https://doi.org/10.1051/0004-6361/202245610' }]
    },
    {
      authors: 'Barret, D., Albouys, V., Herder, J.-W. d., et al., including Janiuk, A.',
      title: 'The Athena X-ray Integral Field Unit: a consolidated design for the system requirement review of the preliminary definition phase',
      journal: 'Experimental Astronomy, Vol. 55, No. 2, 373-426, 2023',
      links: [{ label: 'DOI', url: 'https://doi.org/10.1007/s10686-022-09880-7' }]
    },
    {
      authors: 'Medina Covarrubias, R., De Colle, F., Urrutia, G., Vargas, F.',
      title: 'Numerical simulations of polarization in gamma-ray burst afterglows',
      journal: 'MNRAS, Vol. 523, no. 3, pp. 4583, 2023',
      links: [{ label: 'DOI', url: 'https://doi.org/10.1093/mnras/stad1665' }]
    },
    {
      authors: 'Śniegowska, M., Grzȩdzielski, M., Czerny, B., Janiuk, A.',
      title: 'Modified models of radiation pressure instability applied to 10, 10⁵, and 10⁷ M⊙ accreting black holes',
      journal: 'Astronomy and Astrophysics, Vol. 672, A19, 2023',
      links: [{ label: 'ADS', url: 'https://ui.adsabs.harvard.edu/abs/2023A&A...672A..19S' }]
    },
    {
      authors: 'Janiuk, A.',
      title: 'Neutrino Cooled Disk in Post-merger System Studied via Numerical GR MHD Simulation with a Composition-dependent Equation of State',
      journal: 'Acta Physica Polonica B Proc. Suppl., Vol. 16, A6, 2023',
      links: [{ label: 'Link', url: 'https://www.actaphys.uj.edu.pl/fulltext?series=Sup&vol=16&aid=6-A6' }]
    },
    {
      authors: 'Nouri, F.H., Janiuk, A., Przerwa, M.',
      title: 'Studying Postmerger Outflows from Magnetized-neutrino-cooled Accretion Disks',
      journal: 'The Astrophysical Journal, Vol. 944, no. 2, pp. 220, 2023',
      links: [{ label: 'DOI', url: 'https://doi.org/10.3847/1538-4357/acafe2' }]
    },
    {
      authors: 'Wiśniewicz, M., Gondek-Rosińska, D., Słowikowska, A., Zdziarski, A., Janiuk, A.',
      title: 'Long-term Quasiperiodicity in LMXB 4U 1636–536',
      journal: 'The Astrophysical Journal, Vol. 944, no. 2, pp. 214, 2023',
      links: [{ label: 'DOI', url: 'https://doi.org/10.3847/1538-4357/aca6e9' }]
    },
  ],
  2022: [
    {
      authors: 'Janiuk, A., James, B.',
      title: 'Magnetically arrested accretion disks launching structured jets in application to GRB and AGN engines',
      journal: 'Astronomy & Astrophysics, Vol. 668, A66, 2022',
      links: [{ label: 'DOI', url: 'https://doi.org/10.1051/0004-6361/202244196' }]
    },
    {
      authors: 'James, B., Janiuk, A., Nouri, F.H.',
      title: 'Modeling the Gamma-Ray Burst Jet Properties with 3D General Relativistic Simulations of Magnetically Arrested Accretion Flows',
      journal: 'The Astrophysical Journal, vol. 935, no. 2, 2022',
      links: [
        { label: 'DOI', url: 'https://doi.org/10.3847/1538-4357/ac81b7' },
        { label: 'ADS', url: 'https://ui.adsabs.harvard.edu/abs/2022ApJ...935..176J/abstract' }
      ]
    },
  ],
  2021: [
    {
      authors: 'Janiuk, A.',
      title: 'Many faces of accretion in gamma ray bursts',
      journal: 'arXiv e-prints, 2021',
      links: [{ label: 'arXiv', url: 'https://ui.adsabs.harvard.edu/abs/2021arXiv211214086J/abstract' }]
    },
    {
      authors: 'Mościbrodzka, M., Janiuk, A., De Laurentis, M.',
      title: 'Unraveling circular polarimetric images of magnetically arrested accretion flows near event horizon of a black hole',
      journal: 'Monthly Notices of the Royal Astronomical Society, vol. 508, no. 3, pp. 4282-4296, 2021',
      links: [
        { label: 'DOI', url: 'https://doi.org/10.1093/mnras/stab2790' },
        { label: 'ADS', url: 'https://ui.adsabs.harvard.edu/abs/2021MNRAS.508.4282M/abstract' }
      ]
    },
    {
      authors: 'Janiuk, A., James, B., Palit, I.',
      title: 'Variability of Magnetically Dominated Jets from Accreting Black Holes',
      journal: 'The Astrophysical Journal, vol. 917, no. 2, 2021',
      links: [
        { label: 'DOI', url: 'https://doi.org/10.3847/1538-4357/ac0624' },
        { label: 'ADS', url: 'https://ui.adsabs.harvard.edu/abs/2021ApJ...917..102J/abstract' }
      ]
    },
    {
      authors: 'Janiuk, A., James, B., Sapountzis, K.',
      title: 'Cosmic Gamma Ray Bursts',
      journal: 'Acta Physica Polonica A, vol. 139, no. 3, pp. 273–276, 2021',
      links: [
        { label: 'DOI', url: 'https://doi.org/10.12693/APhysPolA.139.273' },
      ]
    },
    {
      authors: 'Murguia-Berthier, A., Ramirez-Ruiz, E., De Colle, F., Janiuk, A., Rosswog, S., Lee, W. H.',
      title: 'The Fate of the Merger Remnant in GW170817 and Its Imprint on the Jet Structure',
      journal: 'The Astrophysical Journal, vol. 908, no. 2, 2021',
      links: [
        { label: 'DOI', url: 'https://doi.org/10.3847/1538-4357/abd08e' },
      ]
    },
  ],
  2020: [
    {
      authors: 'Karas, V., Sapountzis, K., Janiuk, A.',
      title: 'Magnetically Ejected Disks: Equatorial Outflows Near Vertically Magnetized Black Hole',
      journal: 'arXiv e-prints, 2020',
      links: [{ label: 'arXiv', url: 'https://ui.adsabs.harvard.edu/abs/2020arXiv201215105K/abstract' }]
    },
    {
      authors: 'Janiuk, A., Król, D.',
      title: 'Accretion induced black hole spin up in magnetized collapsars',
      journal: 'arXiv e-prints, 2020',
      links: [{ label: 'arXiv', url: 'https://ui.adsabs.harvard.edu/abs/2020arXiv201203591J/abstract' }]
    },
  ],
};
